// 供應商資料庫
import React, { useEffect, useState } from 'react';
import { api, money } from '../api.js';
import { Modal, Field, Loading, Empty, PageHead, useToast, useConfirm } from '../ui.jsx';

function SupplierEditor({ initial, onSaved, onClose }) {
  const { toast } = useToast();
  const isNew = !initial?.id;
  const [f, setF] = useState({ code: initial?.code || '', name: initial?.name || '', contact: initial?.contact || '', phone: initial?.phone || '', email: initial?.email || '', notes: initial?.notes || '' });
  const set = (k, v) => setF(x => ({ ...x, [k]: v }));
  const save = async () => {
    if (!f.name.trim()) return toast('請填寫供應商名稱', 'err');
    try {
      if (isNew) { await api.post('/suppliers', f); toast('供應商已建立'); }
      else { await api.put(`/suppliers/${initial.id}`, f); toast('供應商已更新'); }
      onSaved();
    } catch (e) { toast(e.message, 'err'); }
  };
  return (
    <Modal onClose={onClose} icon="🏭" title={isNew ? '➕ 新增供應商' : `✏️ 編輯供應商 — ${initial.name}`}
      footer={<><button className="btn" onClick={onClose}>取消</button><button className="btn primary" onClick={save}>💾 儲存</button></>}>
      <div className="form-grid">
        <Field label="供應商編號"><input className="input" value={f.code} onChange={e => set('code', e.target.value)} placeholder="自動產生" /></Field>
        <Field label="公司名稱" required><input className="input" value={f.name} onChange={e => set('name', e.target.value)} /></Field>
        <Field label="聯絡人"><input className="input" value={f.contact} onChange={e => set('contact', e.target.value)} /></Field>
        <Field label="電話"><input className="input" value={f.phone} onChange={e => set('phone', e.target.value)} /></Field>
        <Field label="Email"><input className="input" value={f.email} onChange={e => set('email', e.target.value)} /></Field>
        <Field label="備註" span2><textarea className="textarea" value={f.notes} onChange={e => set('notes', e.target.value)} /></Field>
      </div>
    </Modal>
  );
}

export default function Suppliers() {
  const { toast } = useToast();
  const [confirm, confirmNode] = useConfirm();
  const [rows, setRows] = useState(null);
  const [editor, setEditor] = useState(null);
  const [q, setQ] = useState('');
  const refresh = () => api.get('/suppliers').then(setRows);
  useEffect(() => { refresh(); }, []);
  const del = (s) => confirm(`確定刪除供應商「${s.name}」？`, async () => {
    try { await api.del(`/suppliers/${s.id}`); toast('已刪除'); refresh(); } catch (e) { toast(e.message, 'err'); }
  }, { danger: true, okLabel: '刪除' });
  const filtered = (rows || []).filter(s => !q || s.name.includes(q));
  const totalAP = (rows || []).reduce((s, x) => s + (x.outstanding || 0), 0);

  return (
    <div>
      <PageHead icon="🏭" title="供應商資料庫" desc={`採購夥伴主檔 — 應付未付總額: HK$ ${money(totalAP)}`}
        actions={<>
          <div className="search-box"><input className="input" placeholder="搜尋供應商…" value={q} onChange={e => setQ(e.target.value)} /></div>
          <button className="btn primary" onClick={() => setEditor({})}>➕ 新增供應商</button>
        </>} />
      <div className="card">
        {rows === null ? <Loading /> : filtered.length === 0 ? <Empty icon="🏭" text="沒有供應商" /> : (
          <div className="tbl-wrap">
            <table className="tbl">
              <thead><tr><th>供應商</th><th>聯絡人</th><th>電話</th><th className="num">分判商單</th><th className="num">未付帳款</th><th></th></tr></thead>
              <tbody>
                {filtered.map(s => (
                  <tr key={s.id}>
                    <td>
                      <div className="row" style={{ gap: 10, flexWrap: 'nowrap' }}>
                        <span className="avatar v4">{s.name.slice(0, 1)}</span>
                        <div><div className="strong">{s.name}</div><div className="sub">{s.code}</div></div>
                      </div>
                    </td>
                    <td>{s.contact || '—'}</td>
                    <td>{s.phone || '—'}</td>
                    <td className="num">{s.po_count}</td>
                    <td className="num strong" style={{ color: s.outstanding > 0 ? 'var(--amber)' : undefined }}>{money(s.outstanding)}</td>
                    <td>
                      <div className="row" style={{ flexWrap: 'nowrap' }}>
                        <button className="btn sm" onClick={() => setEditor({ id: s.id })}>✏️</button>
                        <button className="btn sm coral" onClick={() => del(s)}>🗑️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
      {editor && <SupplierEditor initial={editor.id ? rows.find(r => r.id === editor.id) : {}} onClose={() => setEditor(null)} onSaved={() => { setEditor(null); refresh(); }} />}
      {confirmNode}
    </div>
  );
}
